import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import { theme } from '../../theme';
import {
  BaseButton,
  BaseButtonWrapper,
  ButtonLoadingSpinner,
  ButtonProps,
  IconWrapper,
} from './BaseButton';

const StyledTertiaryButton = styled(BaseButton)`
  color: ${theme.colors.system.systemBlue};
  fill: ${theme.colors.system.systemBlue};
  background: ${theme.colors.primary.white};

  &:hover {
    background-color: ${theme.colors.tints.systemBlue['_1']};
    color: white;
  }

  &:active {
    background-color: ${theme.colors.tints.systemBlue['_1']};
  }
`;

export const TertiaryButton: React.FC<ButtonProps> = ({
  children,
  disabled = false,
  fullWidth = false,
  isLoading = false,
  size = 'medium',
  iconLeft: IconLeft,
  iconRight: IconRight,
  iconFill = '',
  iconWidth = 16,
  ...props
}) => {
  const [isFocussed, setIsFocussed] = useState(false);

  useEffect(() => {
    if (disabled) setIsFocussed(false);
  }, [disabled]);

  return (
    <BaseButtonWrapper
      size={size}
      fullWidth={fullWidth}
      isFocussed={isFocussed}
    >
      <StyledTertiaryButton
        disabled={disabled}
        size={size}
        fullWidth={fullWidth}
        isLoading={isLoading}
        onTouchStart={() => setIsFocussed(true)}
        onFocus={() => setIsFocussed(true)}
        onMouseLeave={() => setIsFocussed(false)}
        {...props}
      >
        <IconWrapper>
          {IconLeft && <IconLeft fill={iconFill} width={iconWidth} />}
          {isLoading ? <ButtonLoadingSpinner size={size} /> : children}
          {IconRight && <IconRight fill={iconFill} width={iconWidth} />}
        </IconWrapper>
      </StyledTertiaryButton>
    </BaseButtonWrapper>
  );
};
